/**
 * Holds the state of the drag and drop touch interaction.
 */
export default class DragDropTouch {
  /**
   * If the touch is enabled.
   */
  public static touchHandled: boolean;
  /**
   * The timeout for the pointer enter event.
   */
  public static pointerLeaveTimeout: number;
}